// A LawPay decline is HTTP 402, code LAWPAY_DECLINED, and error set to the
// full sentence (for example "Your card was declined. Nothing was charged."
// plus LawPay's reason). Show that string unchanged. Do not substitute a
// shorter "Card was declined" line.

export function lawpayChargeError(err) {
  if (!err) return '';
  const server = typeof err.serverError === 'string' ? err.serverError.trim() : '';
  const message = typeof err.message === 'string' ? err.message.trim() : '';
  if (err.code === 'LAWPAY_DECLINED') return server || message;
  return message;
}
